import axios from "axios";
import { ReportCategoryOption } from "./models/ReportCategoryOption";
import APP_CONFIG from "../app/configuration/AppConfig";

export interface IGenerateReportRequest {
  reportType: string;
  startDate: string;
  endDate: string;
  outputFormat: "iframe" | "html";
}

const BASE_URL = `${APP_CONFIG.serviceUrls.apiHostUrl}/reports`;

export async function getReportCategoriesAsync(
  siteId: string,
  signal?: AbortSignal
): Promise<ReportCategoryOption[]> {
  const url = `${BASE_URL}/${siteId}/categories`;
  const response = signal
    ? await axios.get<ReportCategoryOption[]>(url, { signal })
    : await axios.get<ReportCategoryOption[]>(url);

  return response.data;
}

export async function generateReportAsync(
  siteId: string,
  request: IGenerateReportRequest
): Promise<string> {
  const url = `${BASE_URL}/${siteId}/generate`;
  const response = await axios.post<string>(url, request, {
    headers: {
      Accept: "text/html",
    },
    responseType: "text",
  });
  return response.data;
}
